import * as React from 'react';
import { withTranslation  } from 'react-i18next';
import { connect } from 'react-redux';
import {pullCollisionDataframesWithToken} from 'Redux/Actions/CollisionActions'
import {HistoryCollision} from './HistoryCollision'
import DefaultPageWrapper from '../Layout/DefaultPageWrapper';
import DetailsSidebar from '../Layout/DetailsSidebar/_DetailsSidebar';
import CollisionDetails from '../Layout/DetailsSidebar/CollisionDetails'

type Props = {
    history?:any,
    t?:any,
    match: any;
  };
type ConnectedProps = {};
interface IDispatchedP {
    getCollisionDataframes:(token:string)=>Function
}

export const HistoryCollisionPageWithTokenHOC = (component:any)=> {
  const ComponentTemp = component;
  return (props:any)=> {
    return (
      <DefaultPageWrapper>
        <ComponentTemp {...props} />
        <DetailsSidebar showUI={false}>
          <CollisionDetails />
        </DetailsSidebar>
      </DefaultPageWrapper>
    )
  }
}

export class HistoryCollisionPageWithToken extends React.Component<Props & ConnectedProps & IDispatchedP,any> {

    public componentDidMount() {
      const { collisionToken } = this.props.match.params;
      this.props.getCollisionDataframes(collisionToken);
    }
  
    public render() {
      return (
          <HistoryCollision/>
      );
    }
}

function mapDispachToProps(dispatch: any): IDispatchedP {
    return {
      getCollisionDataframes:(token:string)=>dispatch(pullCollisionDataframesWithToken(token))
    }
}
  
export default withTranslation ()(connect(
    null,
    mapDispachToProps
)(HistoryCollisionPageWithToken) as React.ComponentClass<any>);



// WEBPACK FOOTER //
// ./src/components/History/HistoryCollisionPageWithToken.tsx